export default {
	FOLDER: '0',
	LESSON: '1',
	HOMEWORK_SHARED_PRESENTATION: '2',
	BUNDLE: '3',
	AUTHOR: '4',
	NONE: '99',
}
